import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import * as Const from "src/app/common/Const";
import { Alginment } from "src/app/common/Const";
import { GC_D2087_REJECTED } from "src/app/common/ConstCcd";
import { GC_H2087_APPL_STATUS_DSP } from "src/app/common/ConstCcdDef";
import { TableColumnDef } from "src/app/common/table-column-def";
import { Req } from "src/app/request/req";
import { ReqAccess } from "src/app/request/req-access";
import { ReqSpmt10311SlipListSearch } from "src/app/request/req-spmt10311-search";
import { Spmt10311SlipListDto } from "src/app/response/rsp-spmt10311-search";
import { KbnSearchDto } from "src/app/response/rsp-tmt050-all-kbn-search";
import { CommonService } from "src/app/service/common.service";
import { HttpBasicService } from "src/app/service/http-basic.service";

enum ColumnIds {
  SlipNo = "slipNo",
  StoreNm = "storeNm",
  DisposalDate = "disposalDate",
  ReqStatusNm = "reqStatusNm",
  RedBlackNm = "redBlackNm",
  SlipCancelNm = "slipCancelNm",
  SlipCreateDate = "slipCreateDate",
  SlipApproveDate = "slipApproveDate",
  SlipChangeDate = "slipChangeDate",
  SlipCancelDate = "slipCancelDate",
  RequesterNm = "requesterNm",
  ApproverNm = "approverNm",
}

enum ColumnHeaders {
  SlipNo = "伝票番号",
  StoreNm = "店舗",
  DisposalDate = "廃棄日",
  ReqStatusNm = "申請状態",
  RedBlackNm = "赤黒区分",
  SlipCancelNm = "伝票取消フラグ",
  SlipCreateDate = "伝票登録日",
  SlipApproveDate = "伝票承認日",
  SlipChangeDate = "伝票訂正日",
  SlipCancelDate = "伝票取消日",
  RequesterNm = "申請者",
  ApproverNm = "承認者",
}

class Constant {
  public static readonly ZERO_NUMBER = "0";
  public static readonly SLIP_CREATE_DATE_FROM_CTRL = "slipCreateDateFrom";
  public static readonly SLIP_CREATE_DATE_TO_CTRL = "slipCreateDateTo";
  public static readonly REQ_STATUS_CTRL = "reqStatus";
  public static readonly REQUESTER_CD_CTRL = "requesterCd";
  public static readonly APPROVER_CD_CTRL = "approverCd";
  public static readonly DISPOSAL_DATE_FROM_CTRL = "disposalDateFrom";
  public static readonly DISPOSAL_DATE_TO_CTRL = "disposalDateTo";
  public static readonly RED_BLACK_FLG_CTRL = "redBlackFlg";
}

@Component({
  selector: "app-spmt10311-slip-list-dialog",
  templateUrl: "./spmt10311-slip-list-dialog.component.html",
  styleUrls: ["./spmt10311-slip-list-dialog.component.css"],
})
export class Spmt10311SlipListDialogComponent implements OnInit {
  formGroup: FormGroup;
  dataSource = new MatTableDataSource<Spmt10311SlipListDto>();
  recordCount: number = 0;
  tableHeight: number = 314;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  storeSearchConditions: any = {};

  displayedColumns: string[] = [
    ColumnIds.SlipNo,
    ColumnIds.StoreNm,
    ColumnIds.DisposalDate,
    ColumnIds.ReqStatusNm,
    ColumnIds.RedBlackNm,
    ColumnIds.SlipCancelNm,
    ColumnIds.SlipCreateDate,
    ColumnIds.SlipApproveDate,
    ColumnIds.SlipChangeDate,
    ColumnIds.SlipCancelDate,
    ColumnIds.RequesterNm,
    ColumnIds.ApproverNm,
  ];
  userList: { userID: string; userName: string }[] = [];
  reqStatusList: KbnSearchDto[] = [];

  columnDefs: TableColumnDef[] = [
    { columnId: ColumnIds.SlipNo, header: ColumnHeaders.SlipNo, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.StoreNm, header: ColumnHeaders.StoreNm, width: 120, align: Alginment.Left },
    { columnId: ColumnIds.DisposalDate, header: ColumnHeaders.DisposalDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.ReqStatusNm, header: ColumnHeaders.ReqStatusNm, width: 70, align: Alginment.Left },
    { columnId: ColumnIds.RedBlackNm, header: ColumnHeaders.RedBlackNm, width: 70, align: Alginment.Left },
    { columnId: ColumnIds.SlipCancelNm, header: ColumnHeaders.SlipCancelNm, width: 90, align: Alginment.Left },
    { columnId: ColumnIds.SlipCreateDate, header: ColumnHeaders.SlipCreateDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.SlipApproveDate, header: ColumnHeaders.SlipApproveDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.SlipChangeDate, header: ColumnHeaders.SlipChangeDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.SlipCancelDate, header: ColumnHeaders.SlipCancelDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.RequesterNm, header: ColumnHeaders.RequesterNm, width: 90, align: Alginment.Left },
    { columnId: ColumnIds.ApproverNm, header: ColumnHeaders.ApproverNm, width: 90, align: Alginment.Left },
  ];

  constructor(
    public dialogRef: MatDialogRef<Spmt10311SlipListDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      access: ReqAccess;
      storeCd: string;
      storeNm: string;
    },
    private readonly fb: FormBuilder,
    public commonService: CommonService,
    private readonly httpBasic: HttpBasicService
  ) {
    this.formGroup = this.fb.group({
      requesterCd: [commonService.loginUser.userId],
      reqStatus: fb.array([]),
      disposalDateFrom: [""],
      disposalDateTo: [""],
      slipCreateDateFrom: [new Date()],
      slipCreateDateTo: [new Date()],
      approverCd: [""],
    });
  }

  getKbnList(callBack: () => void) {
    const rcdKbns = [GC_H2087_APPL_STATUS_DSP];
    const request = {
      access: this.data.access,
      rcdKbns,
    };
    this.httpBasic.beforeRequestStart(Const.LoadingMessages.Initializing);
    return this.httpBasic.tmt050AllKbnSearch(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.reqStatusList = res.rows.filter((row) => row.rcdKbn === GC_H2087_APPL_STATUS_DSP);
        callBack();
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  getUserLists() {
    let request: Req = {
      access: this.commonService.loginUser,
    };
    this.httpBasic.beforeRequestStart(Const.LoadingMessages.Initializing);
    this.httpBasic.generalRequest("GetUserList", request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.userList = res.rows;
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  btnSearchClick() {
    if (!this.formGroup.valid) {
      return;
    }
    this.paginator.pageIndex = 0;
    let reqStatus: string[] = [];
    const reqStatusFormArray = this.formGroup.get(Constant.REQ_STATUS_CTRL) as FormArray;
    this.reqStatusList.forEach((item, i) => {
      if (reqStatusFormArray.value[i]) {
        reqStatus.push(item.kbn);
      }
    });
    this.storeSearchConditions = {
      storeCd: this.data.storeCd,
      requesterCd: this.formGroup.get(Constant.REQUESTER_CD_CTRL).value,
      reqStatus: reqStatus,
      disposalDateFrom: this.commonService.dateToString(this.formGroup.get(Constant.DISPOSAL_DATE_FROM_CTRL).value),
      disposalDateTo: this.commonService.dateToString(this.formGroup.get(Constant.DISPOSAL_DATE_TO_CTRL).value),
      slipCreateDateFrom: this.commonService.dateToString(this.formGroup.get(Constant.SLIP_CREATE_DATE_FROM_CTRL).value),
      slipCreateDateTo: this.commonService.dateToString(this.formGroup.get(Constant.SLIP_CREATE_DATE_TO_CTRL).value),
      approverCd: this.formGroup.get(Constant.APPROVER_CD_CTRL).value,
    };
    this.fnSearch();
  }

  pageChanged() {
    this.fnSearch();
  }

  private fnSearch() {
    const req: ReqSpmt10311SlipListSearch = {
      access: this.data.access,
      ...this.storeSearchConditions,
      pageInfo: { pageNum: this.paginator.pageIndex, dispNum: this.paginator.pageSize },
    };
    this.httpBasic.beforeRequestStart(Const.LoadingMessages.Searching);
    this.httpBasic.spmt10311SlipListSearch(req).subscribe({
      next: (data) => {
        if (this.httpBasic.handleAppError(data)) return;
        this.dataSource.data = data.rows;
        this.recordCount = data.recordCount;
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  onRowClick(row: Spmt10311SlipListDto): void {
    let temp = !row.highlightFlg;
    this.dataSource.data.forEach((x) => (x.highlightFlg = false));
    row.highlightFlg = temp;
  }

  btnSelectClick() {
    const hightlightRow = this.dataSource.data.find((x) => x.highlightFlg);
    if (!hightlightRow) {
      return;
    }
    this.dialogRef.close(hightlightRow);
  }

  btnCloseClick() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.getUserLists();
    this.getKbnList(() => {
      const reqStatus: FormArray = this.formGroup.get(Constant.REQ_STATUS_CTRL) as FormArray;
      this.reqStatusList.forEach((item) => {
        const isTrue = item.kbn !== GC_D2087_REJECTED;
        reqStatus.push(new FormControl(isTrue));
      });
    });
  }

  isBtnSelectDisabled(): boolean {
    return this.dataSource.data.every((x) => !x.highlightFlg);
  }
}
